// DirectivoLayout — shell del rol directivo: header común + SIDEBAR con los
// grupos del rediseño 2026-07 (antes top-nav horizontal; los mockups nuevos
// del responsable traen menú lateral, mismo patrón que RoleLayout).
//
// No reusa RoleLayout porque ese shell agrega la tira "← Volver al pulso"
// cuando el user es directivo — correcta en el cruce de mundos (drill al
// coordinador), redundante dentro del propio mundo directivo.

import { useState, type ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import { DirectivoSidebar } from './DirectivoSidebar';
import { useDensity } from '../../lib/theme/density';
import { useAuth } from '../../lib/auth';

export function DirectivoLayout({
  children,
  headerExtra,
}: {
  children: ReactNode;
  /** Contenido extra a la derecha del header (ej. día operativo · corte). */
  headerExtra?: ReactNode;
}) {
  const { density } = useDensity();
  const showSidebar = density === 'desktop';
  const [menuOpen, setMenuOpen] = useState(false);

  // Nombre del tenant ACTIVO desde los claims (antes decía "UPG" hardcodeado
  // — un directivo de Robotpack veía el nombre de otro tenant).
  const { state } = useAuth();
  const tenantNombre =
    state.kind === 'signed_in'
      ? (state.claims.tenants_disponibles.find((t) => t.id === state.claims.tenant_id_activo)
          ?.nombre ?? '')
      : '';

  return (
    <div className="flex h-screen flex-col bg-surface-base text-fg">
      <AppHeader
        roleLabel={tenantNombre ? `${tenantNombre} · Directivo` : 'Directivo'}
        extra={headerExtra}
        onMenuToggle={showSidebar ? undefined : () => setMenuOpen(true)}
      />
      {/* Drawer mobile: backdrop + el mismo sidebar. Tocar un link o el fondo
          lo cierra (mismo comportamiento que RoleLayout). */}
      {!showSidebar && menuOpen ? (
        <div className="fixed inset-0 z-50 flex">
          <div
            className="h-full w-64 overflow-y-auto border-r border-border bg-surface-base shadow-xl"
            onClickCapture={(e) => {
              if ((e.target as HTMLElement).closest('a')) setMenuOpen(false);
            }}
          >
            <DirectivoSidebar />
          </div>
          <button
            type="button"
            aria-label="Cerrar menú"
            className="flex-1 bg-black/50"
            onClick={() => setMenuOpen(false)}
          />
        </div>
      ) : null}
      <div className="flex min-h-0 flex-1">
        {showSidebar ? <DirectivoSidebar /> : null}
        <main className="flex-1 overflow-y-auto px-4 py-6 md:px-6 md:py-7">{children}</main>
      </div>
    </div>
  );
}
